import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_PRODUCTS: string = '[ecommerce products] Load Ecommerce Products';
export const LOAD_ECOMMERCE_PRODUCTS_SUCCESS: string = '[ecommerce products] Load Ecommerce Products Success';
export const LOAD_ECOMMERCE_PRODUCTS_FAIL: string = '[ecommerce products] Load Ecommerce Products Fail';

export const LOAD_ECOMMERCE_PRODUCT_DROPDOWNS: string = '[ecommerce product dropdowns] Load Ecommerce Product Dropdowns';
export const LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_SUCCESS: string = '[ecommerce product dropdowns] Load Ecommerce Product Dropdowns Success';
export const LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_FAIL: string = '[ecommerce product dropdowns] Load Ecommerce Product Dropdowns Fail';

export const LOAD_ECOMMERCE_PRODUCT_VARIATIONS: string = '[ecommerce product variations] Load Ecommerce Product Variations';
export const LOAD_ECOMMERCE_PRODUCT_VARIATIONS_SUCCESS: string = '[ecommerce product variations] Load Ecommerce Product Variations Success';
export const LOAD_ECOMMERCE_PRODUCT_VARIATIONS_FAIL: string = '[ecommerce product variations] Load Ecommerce Product Variations Fail';

export const LOAD_ECOMMERCE_PRODUCT: string = '[ecommerce product] Load Ecommerce Product';
export const LOAD_ECOMMERCE_PRODUCT_SUCCESS: string = '[ecommerce product] Load Ecommerce Product Success';
export const LOAD_ECOMMERCE_PRODUCT_FAIL: string = '[ecommerce product] Load Ecommerce Product Fail';

export class LoadEcommerceProducts implements Action {
  readonly type: string = LOAD_ECOMMERCE_PRODUCTS;

  constructor(public payload: { websiteId: number, order?: 'asc' | 'desc', search?: string, status?: string }) {
  }
}

export class LoadEcommerceProductsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCTS_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    entities: any,
    productsCount: number
  }) {
  }

}

export class LoadEcommerceProductsFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCTS_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceProductDropdowns implements Action {
  readonly type: string = LOAD_ECOMMERCE_PRODUCT_DROPDOWNS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceProductDropdownsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    dropdowns: any,
  }) {
  }

}

export class LoadEcommerceProductDropdownsFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceProductVariations implements Action {
  readonly type: string = LOAD_ECOMMERCE_PRODUCT_VARIATIONS;

  constructor(public payload: { websiteId: number, id: number }) {
  }
}

export class LoadEcommerceProductVariationsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_VARIATIONS_SUCCESS;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceProductVariationsFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_VARIATIONS_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceProduct implements Action {
  readonly type: string = LOAD_ECOMMERCE_PRODUCT;
  constructor(public payload: { websiteId: number, id: number; }) {
  }
}

export class LoadEcommerceProductSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_SUCCESS;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceProductFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_PRODUCT_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceProductsAction =
  LoadEcommerceProducts
  | LoadEcommerceProductsSuccess
  | LoadEcommerceProductsFails
  |
  LoadEcommerceProductDropdowns
  | LoadEcommerceProductDropdownsSuccess
  | LoadEcommerceProductDropdownsFails
  |
  LoadEcommerceProductVariations
  | LoadEcommerceProductVariationsSuccess
  | LoadEcommerceProductVariationsFails
  |
  LoadEcommerceProduct
  | LoadEcommerceProductSuccess
  | LoadEcommerceProductFails;
